<template>
  <div class="invoice-ticket">
    <div class="header">
      <div class="serial">
        <p v-if="data.invoiceCode">{{ $t('invoice_ticket.fa_piao_liu_shui_hao') }} {{ data.invoiceCode }}</p>
        <p v-if="data.gmtCreate">{{ $t('invoice_ticket.shen_qing_ri_qi') }}{{ $momentLocal(data.gmtCreate, 'YYYY-MM-DD') }}</p>
      </div>
      <h2>{{getItemNameByTypeAndClass(data.invoiceType, data.invoiceClass)}}</h2>
      <div class="date" v-if="data.invoiceNum || data.invoiceTime">
        <h3 v-if="data.invoiceNum">No {{ data.invoiceNum }}</h3>
        <p v-if="data.invoiceTime">{{ $t('invoice_ticket.kai_piao_ri_qi') }}{{ $momentLocal(data.invoiceTime, 'YYYY-MM-DD') }}</p>
      </div>
    </div>
    <div class="main">
      <div class="purchaseArea">
        <div class="purchaser">
          <div class="title">{{ $t('invoice_ticket.gou_mai_fang') }}</div>
          <div class="name">
            <p>
              {{$t('invoice_ticket.ming_cheng')}}：
              <span>{{ data.buyerName }}</span>
            </p>
            <p>
              {{ $t('invoice_ticket.nsrsbh') }}
              <span>{{ data.buyerNumber }}</span>
            </p>
            <p>
              {{$t('invoice_ticket.di_zhi_dian_hua')}}：
              <span>{{ data.buyerRegisterAddress }} {{ data.buyerMobile }}</span>
            </p>
            <p>
              {{ $t('invoice_ticket.khhjzh') }}
              <span>{{ data.buyerDepositBank }} {{ data.buyerDepositNumber }}</span>
            </p>
          </div>
        </div>
        <div class="passwordArea">
          <div class="title">{{ $t('invoice_ticket.mi_ma_qu') }}</div>
          <div class="hidden"></div>
        </div>
      </div>
      <div class="order">
        <ul>
          <li class="theader">
            <div>{{$t('invoice_ticket.hwhyslwfwmc')}}</div>
            <div>{{ $t('invoice_ticket.gui_ge_xing_hao') }}</div>
            <div>{{ $t('invoice_ticket.dan_wei') }}</div>
            <div>{{ $t('invoice_ticket.shu_liang') }}</div>
            <div>{{ $t('invoice_ticket.dan_jia') }}</div>
            <div>{{ $t('invoice_ticket.jin_e') }}</div>
            <div>{{ $t('invoice_ticket.shui_lv') }}</div>
            <div>{{ $t('invoice_ticket.shui_e') }}</div>
          </li>
          <li class="line" v-for="item in data.invoiceItemList" :key="item.billId">
            <!-- {{ service_name}} -->
            <div>
              <!-- {{ getDicValue('service_name',item.itemName) }} -->
              {{ item.itemName }}
            </div>
            <div>{{ item.itemSpec }}</div>
            <div>{{ item.itemUnit }}</div>
            <div>
              <i v-if="type">-</i>
              {{ item.itemNum }}
            </div>
            <div>{{ (item.itemPrice/(1+(item.taxRate/100))).toFixed(2) }}</div>
            <div>
              <i v-if="type">-</i>
              {{(item.itemPrice*item.itemNum/(1+(item.taxRate/100))).toFixed(2)}}
              <!-- {{ (item.itemAmount - item.taxAmount).toFixed(2) }} -->
            </div>
            <div>{{ item.taxRate }}%</div>
            <div>
              <i v-if="type">-</i>
              {{ ((item.itemPrice*item.itemNum/(1+(item.taxRate/100)))*(item.taxRate/100)).toFixed(2) }}
            </div>
          </li>
          <li class="total">
            <div>{{ $t('invoice_ticket.he_ji') }}</div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <template v-if="type">
              <div>-￥{{ totalAmount.toFixed(2) }}</div>
              <div></div>
              <div>-￥{{ totaltaxAmount.toFixed(2) }}</div>
            </template>
            <template v-else>
              <div>￥{{ totalAmount.toFixed(2) }}</div>
              <div></div>
              <div>￥{{ totaltaxAmount.toFixed(2)}}</div>
            </template>
          </li>
        </ul>
      </div>
      <div class="total-tax">
        <div class="tax-title">{{ $t('invoice_ticket.jshjdx') }}</div>
        <template v-if="type">
          <div class="tax-left">{{ $t('invoice_ticket.fu') }}{{ $moneyToCapital(+data.invoiceAmount) }}</div>
          <div class="tax-right">{{ $t('invoice_ticket.xiao_xie') }}{{ data.invoiceAmount.toFixed(2) }}</div>
          <!-- <div class="tax-left">
            负{{ $moneyToCapital(+data.redinvoiceAmount) }}
          </div>
          <div class="tax-right">（小写）-￥{{ data.redinvoiceAmount }}</div> -->
        </template>
        <template v-else>
          <div class="tax-left">
            {{ $moneyToCapital(+data.invoiceAmount) }}
          </div>
          <div class="tax-right">{{ $t('invoice_ticket.xiao_xie') }}{{ data.invoiceAmount.toFixed(2) }}</div>
        </template>
      </div>
      <div class="sales">
        <div class="seller">
          <div class="title">{{ $t('invoice_ticket.xiao_shou_fang') }}</div>
          <div class="name">
            <p>
              {{$t('invoice_ticket.ming_cheng')}}：
              <span>{{ data.sellerName }}</span>
            </p>
            <p>
              {{ $t('invoice_ticket.nsrsbh') }}
              <span>{{ data.sellerNumber }}</span>
            </p>
            <p>
              {{$t('invoice_ticket.di_zhi_dian_hua')}}：
              <span>{{ data.sellerRegisterAddress }} {{ data.sellerMobile }}</span>
            </p>
            <p>
              {{ $t('invoice_ticket.khhjzh') }}
              <span>{{ data.sellerDepositBank }} {{ data.sellerDepositNumber }}</span>
            </p>
          </div>
        </div>
        <div class="remark">
          <div class="title">{{ $t('Common.com_remark') }}</div>
          <div class="text">
            {{ data.invoiceRemark }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import invoiceTypeMixins from '@/utils/invoice_type_mixins.js';

export default {
  mixins: [invoiceTypeMixins],
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    type: { type: Boolean, default: false }
  },
  computed: {
    invoiceTime: function () {
      return moment(this.data.invoiceTime).format('YYYY-MM-DD');
    },
    totalAmount: function () {
      // return (this.data.invoiceItemList && this.data.invoiceItemList.reduce((sum, next) => sum + next.itemAmount, 0)) || 0;
      return (this.data.invoiceItemList && this.data.invoiceItemList.reduce((sum, next) => sum + (next.itemPrice * next.itemNum / (1 + (next.taxRate / 100)).toFixed(2)), 0)) || 0;
    },
    totaltaxAmount: function () {
      // return (this.data.invoiceItemList && this.data.invoiceItemList.reduce((sum, next) => sum + next.taxAmount, 0)) || 0;
      return (this.data.invoiceItemList && this.data.invoiceItemList.reduce((sum, next) => sum + ((next.itemPrice * next.itemNum / (1 + (next.taxRate / 100))).toFixed(2) * (next.taxRate / 100)), 0)) || 0;
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.getCompDictionary();
  },
  methods: {}
};
</script>

<style lang="scss">
.invoice-ticket {
  // width: 925px;
  border: 1px solid #800000;
  margin: 0 auto 20px;
  padding: 0 48px 20px;
  min-width: 1100px;
  .header {
    text-align: center;
    position: relative;
    height: 118px;
    border-left: 1xp solid #800000;
    border-right: 1xp solid #800000;
    h2 {
      color: #9f5008;
      padding-bottom: 10px;
      border-bottom: 1px solid #800000;
      letter-spacing: 3px;
      border-bottom-style: double;
      border-bottom-width: 4px;
      display: inline-block;
      text-align: center;
      font-size: 28px;
      line-height: 40px;
      margin-top: 32px;
    }
    .serial {
      position: absolute;
      left: 0;
      bottom: 25px;
      color: #000000;
      text-align: left;
      p {
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        // letter-spacing:1px;
      }
    }
    .date {
      position: absolute;
      right: 0;
      bottom: 25px;
      color: #000000;
      text-align: right;
      h3 {
        height: 25px;
        font-size: 18px;
        padding-bottom: 8px;
        line-height: 25px;
        letter-spacing: 1px;
      }
      p {
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 1px;
      }
    }
  }
  .main {
    color: #9f5008;
    border-left: 1px solid #800000;
    border-right: 1px solid #800000;
    border-bottom: 1px solid #800000;
    .purchaseArea {
      display: flex;
      // flex-direction:column;
      height: 100px;
      .purchaser {
        width: 530px;
        flex: 0 0 530px;
        display: flex;
        .title {
          // writing-mode: tb-rl;
          width: 30px;
          flex: 0 0 30px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          // line-height: 100px
          padding: 15px 8px;
        }
        .name {
          width: 500px;
          padding-left: 10px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          p {
            padding: 3px 0;
            font-size: 12px;
            span {
              color: #000000;
            }
          }
        }
      }
      .passwordArea {
        flex: 1;
        display: flex;
        .title {
          // writing-mode: tb-rl;
          width: 30px;
          flex: 0 0 30px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          padding: 15px 8px;
          height: 100px;
        }
        .hidden {
          flex: 1;
          padding-left: 10px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          border-right: 0;
        }
      }
    }
    .order {
      li {
        display: flex;

        div {
          padding: 0 10px;
          flex: 1;
          border: 1px solid #800000;
          border-bottom: 0;
          border-left: 0;
          border-top: 0;
          text-align: center;
          // border-right:0
        }
        div:first-of-type {
          flex: 0 0 200px;
        }
        div:last-of-type {
          border-right: 0;
        }
      }

      .theader {
        border-top: 1px solid #800000;
        height: 35px;
        line-height: 35px;
        font-size: 12px;
      }
      .line {
        // padding-top:6px;
        color: #000000;
        line-height: 17px;
        font-size: 12px;
        div {
          padding-top: 6px;
        }
      }
      .total {
        height: 50px;
        line-height: 70px;
        color: #000000;
        div:first-of-type {
          color: #9f5008;
        }
      }
    }
    .total-tax {
      height: 36px;
      line-height: 36px;
      display: flex;
      div {
        border: 1px solid #800000;
        border-left: 0;
        border-bottom: 0;
        border-right: 0;
      }
      .tax-title {
        flex: 0 0 200px;
        border-right: 1px solid #800000;
        text-align: center;
      }
      .tax-left {
        flex: 1;
        padding-left: 20px;
        color: #000000;
      }
      .tax-right {
        flex: 1;
        padding-left: 20px;
        color: #000000;
      }
    }
    .sales {
      display: flex;
      // flex-direction:column;
      height: 100px;
      .seller {
        width: 530px;
        flex: 0 0 530px;
        display: flex;
        .title {
          width: 30px;
          flex: 0 0 30px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          // line-height: 100px
          padding: 15px 8px;
        }
        .name {
          width: 500px;
          padding-left: 10px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
        }
        p {
          padding: 3px 0;
          font-size: 12px;
          span {
            color: #000000;
          }
        }
      }
      .remark {
        flex: 1;
        display: flex;
        .title {
          // writing-mode: tb-rl;
          width: 30px;
          flex: 0 0 30px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          padding: 15px 8px;
          height: 100px;
        }
        .text {
          flex: 1;
          padding-left: 10px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          border-right: 0;
          color: #000000;
        }
      }
    }
  }
  .footer {
    border-top: 1px solid #800000;
    line-height: 36px;
    color: #9f5008;
    span {
      color: #000000;
    }
  }
}
</style>
